import Decimal from "decimal.js-light";
import { InvoiceItemModel } from "src/models/InvoiceItemModel";
import { AmountType } from "types/code-generator";
import { v4 as uuid } from "uuid";
import calculateInvoiceItemBalance from "./calculateInvoiceItemBalance";

interface CalculateFeesInput {
  invoiceItems: {
    id?: string;
    amount: number;
    credit?: { amount: number };
    groupRegistration?: {
      id: string;
      class?: {
        fees?: {
          id: string;
        }[];
      };
    };
    privateSerie?: {
      id: string;
      offering?: {
        fees?: {
          id: string;
        }[];
      };
    };
    membership?: {
      id: string;
      offering?: {
        fees?: {
          id: string;
        }[];
      };
    };
    addon?: {
      fees?: {
        id: string;
      }[];
    };
  }[];
  fees: {
    id: string;
    amount: number;
    amountType: AmountType;
    title: string;
    availableForAllOfferings?: boolean;
  }[];
}

export default ({
  invoiceItems,
  fees,
}: CalculateFeesInput): InvoiceItemModel[] => {
  const feesToAdd = {};

  for (const fee of fees) {
    for (const invoiceItem of invoiceItems) {
      if (invoiceItem.credit) {
        continue;
      }

      let feeAmount = fee.amount;
      let invoiceItemAmount = calculateInvoiceItemBalance(invoiceItem);
      // let coupon;

      if (fee.amountType === AmountType.Percent) {
        const amount = fee.amount || 0;

        const rawAmount = new Decimal(
          invoiceItemAmount.totalOwed * (amount / 100)
        );

        feeAmount = rawAmount.toInteger().toNumber();
      }

      const groupRegistrationHasFee =
        invoiceItem.groupRegistration?.class?.fees?.find(
          (f) => f.id === fee.id
        );

      const privateSerieHasFee = invoiceItem.privateSerie?.offering?.fees?.find(
        (f) => f.id === fee.id
      );

      const membershipHasFee = invoiceItem.membership?.offering?.fees?.find(
        (f) => f.id === fee.id
      );

      const addonHasFee = invoiceItem.addon?.fees?.find((f) => f.id === fee.id);

      if (
        groupRegistrationHasFee ||
        privateSerieHasFee ||
        membershipHasFee ||
        addonHasFee ||
        fee.availableForAllOfferings
      ) {
        if (feeAmount > 0) {
          if (feesToAdd[fee.id]) {
            feesToAdd[fee.id].amount += feeAmount;
          } else {
            feesToAdd[fee.id] = {
              id: fee.id,
              amount: feeAmount,
              description: fee.title,
              fee,
            };
          }
        }
      }
    }
  }

  const feeInvoiceItems = Object.keys(feesToAdd).map((f) => ({
    ...feesToAdd[f],
    id: uuid(),
  }));

  return feeInvoiceItems;
};
